import React from 'react';

interface IconQRcodeProps {
    iconClasses?: string;
}

const IconQRcode: React.FC<IconQRcodeProps> = ({ iconClasses }) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-qr-code ${iconClasses ?? ''}`}
        >
            <path
                d="M20.8315 26.16H25.2995C26.632 26.16 27.7118 24.7632 27.7118 23.0535V20.9917M20.8315 4.36963H25.2995C26.632 4.36963 27.7118 5.75523 27.7118 7.46503V9.53803M4.71191 9.53803V7.46503C4.71191 5.75533 5.79181 4.36963 7.12421 4.36963H11.5835M4.71191 20.9916V23.0534C4.71191 24.7631 5.79181 26.1599 7.12421 26.1599H11.5835"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8315 26.16H25.2995C26.632 26.16 27.7118 24.7632 27.7118 23.0535V20.9917M20.8315 4.36963H25.2995C26.632 4.36963 27.7118 5.75523 27.7118 7.46503V9.53803M4.71191 9.53803V7.46503C4.71191 5.75533 5.79181 4.36963 7.12421 4.36963H11.5835M4.71191 20.9916V23.0534C4.71191 24.7631 5.79181 26.1599 7.12421 26.1599H11.5835"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.8023 21.3734H21.3074C22.0545 21.3734 22.6599 20.5904 22.6599 19.6318V18.4757M18.8023 9.15635H21.3074C22.0545 9.15635 22.6599 9.93325 22.6599 10.8918V12.0541M9.76465 12.054V10.8917C9.76465 9.93315 10.3701 9.15625 11.1171 9.15625H13.6173M9.76465 18.4756V19.6316C9.76465 20.5902 10.3701 21.3734 11.1171 21.3734H13.6173"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.8023 21.3734H21.3074C22.0545 21.3734 22.6599 20.5904 22.6599 19.6318V18.4757M18.8023 9.15635H21.3074C22.0545 9.15635 22.6599 9.93325 22.6599 10.8918V12.0541M9.76465 12.054V10.8917C9.76465 9.93315 10.3701 9.15625 11.1171 9.15625H13.6173M9.76465 18.4756V19.6316C9.76465 20.5902 10.3701 21.3734 11.1171 21.3734H13.6173"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.71289 15.265H27.7129"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconQRcode;
